import { FC, PropsWithChildren, memo, useCallback } from 'react';
import { ButtonWrapper } from '@tempusfinance/common-ui';

import './ButtonTertiary.scss';

interface ButtonTertiaryProps {
  darkBg?: boolean;
  className?: string;
  onClick?: () => void;
}

const ButtonTertiaryComponent: FC<PropsWithChildren<ButtonTertiaryProps>> = ({
  onClick,
  darkBg,
  children,
  className = '',
}) => {
  const handleClick = useCallback(() => {
    onClick?.();
  }, [onClick]);

  return (
    <ButtonWrapper onClick={handleClick}>
      <div className={`nostra__buttonTertiary ${className}`} data-dark-bg={darkBg}>
        {children}
      </div>
    </ButtonWrapper>
  );
};
export const ButtonTertiary = memo(ButtonTertiaryComponent);
